import React, {useState} from "react";
import {IconButton, Tooltip} from "@mui/material";
import {Download} from "@mui/icons-material";
import {translateFunction} from "../../localization/TranslationService";

const translate = translateFunction();

export function DownloadButton(props: { name: string; getText: () => string }) {
	const [open, setOpen] = useState<boolean>(false);
	
	async function downloadHandler() {
		await download(props.name, props.getText());
		
		setOpen(true);
		
		setTimeout(() => setOpen(false), 1_000);
	}
	
	return <IconButton
		aria-label="copy"
		color="primary"
		size="small"
		disabled={open}
		onClick={downloadHandler}>
		<Download
			style={{
				fontSize: "16px"
			}}/>
		<Tooltip title={translate("Downloaded!")} open={open}>
			<div></div>
		</Tooltip>
	</IconButton>;
}

export interface DownloadOptions {
	readonly data?: string;
}

export function download(filename: string, text: string, options: DownloadOptions = {}) {
	const element = document.createElement("a");
	element.setAttribute("href", `data:${options.data || "text/plain"};charset=utf-8,` + encodeURIComponent(text));
	element.setAttribute("download", filename);
	
	element.style.display = "none";
	document.body.appendChild(element);
	element.click();
	document.body.removeChild(element);
}
